// extracted by mini-css-extract-plugin
export default {"useTaskDescription":"RoadmapDescription_useTaskDescription__2binB","noMargin":"RoadmapDescription_noMargin__3Csrv"};